import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { toLocalNumberFormat } from '../../utils/toLocalNumberFormat.js';
import { InputRange } from '../InputRange/InputRange.js';
const DEFAULT_MONEY_STEP = 1000;
export const renderWantedSumInput = ({ isShowItems = true, step = DEFAULT_MONEY_STEP, postfix = '₽', ...rest }) => (_jsx(InputRange, { items: isShowItems
        ? [
            `От ${toLocalNumberFormat(1)(rest.min || 0)} ${postfix}`,
            `До ${toLocalNumberFormat(1)(rest.max || 0)} ${postfix}`,
        ]
        : [], step: step, ...rest }));
//# sourceMappingURL=renderWantedSumInput.js.map